<template>
    <div class="CRMList pa-3">
        <v-text-field
            outlined
            dense
            hide-details
            v-model="searchKey"
            class="mb-3"
            :label="this.$f.tc('search')"
        ></v-text-field>
        <FCIDataTable :items="filterItems" :headers="headers">
            <template v-slot:action="props">
                <template v-if="!props.item.built_in">
                    <v-btn icon>
                        <v-icon @click="deleteItem(props.item)">mdi-delete</v-icon>
                    </v-btn>
                </template>
            </template>
        </FCIDataTable>
        <v-btn color="primary" class="mt-3" @click="addItem">{{ $f.tc('add') }}</v-btn>
    </div>
</template>

<script>
import ListViewMixin from '@/modules/fptai/mixins/ListViewMixin'
import { CrmService } from '@/services/bot.service'
import { AppEventBusType } from '@/eventbus/app.eventbus'

export default {
    name: 'CRMList',
    mixins: [ListViewMixin],
    data () {
        return {
            schema: null
        }
    },
    computed: {
        headers () {
            return [
                {
                    text: this.$f.tc('field'),
                    value: 'name'
                },
                {
                    text: this.$f.tc('action'),
                    value: 'action',
                    type: 'custom'
                }
            ]
        }
    },
    methods: {
        refresh () {
            CrmService.search(this.$route.params.botCode).then(result => {
                this.schema = result.data
                this.updateData()
            })
        },
        updateData () {
            this.items = (this.schema.built_in.map(item => ({
                name: item,
                built_in: true
            }))).concat(this.schema.attributes.map(item => ({
                name: item,
                built_in: false
            })))
        },
        addItem () {
            this.$appService.useEventBus(
                AppEventBusType.EDIT_TEXT,
                {
                    title: this.$f.tc('crm'),
                    text: ''
                }
            ).then(text => {
                CrmService.create(this.$route.params.botCode, {
                    attributes: this.schema.attributes.concat(text)
                }).then(result => {
                    this.schema = result.data
                    this.updateData()
                })
            })
        },
        onDeleteItem (item) {
            let index = this.schema.attributes.indexOf(item)
            this.schema.attributes.splice(index, 1)
            CrmService.create(this.$route.params.botCode, {
                attributes: this.schema.attributes
            }).then(result => {
                this.schema = result.data
                this.updateData()
            })
        }
    }
}
</script>

<style scoped lang="scss">

</style>
